/* eslint-disable no-dupe-keys */
import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import ReactPlayer from 'react-player';
import bannerImage from '../assets/fondos/3.jpg';
import WhatsAppButton from '../components/WhatsAppButton';
import useFacebookPixel from "../hooks/useFacebookPixel";
import cirpImage from '../assets/img/cirp_icon.png';
import SocialButtons from "../components/SocialButton";
import "./recuadro.css";

const Producto1 = () => {
  const { usuario } = useParams();
  useFacebookPixel(usuario); 
  const { trackContact, trackViewContent } = useFacebookPixel(usuario);
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [showQuestion, setShowQuestion] = useState(false);
  const [videoEnded, setVideoEnded] = useState(false);
  const playerRef = useRef(null);
  
  const loginUserJSON = window.localStorage.getItem('loginUser');
  const loggedInUser = loginUserJSON ? JSON.parse(loginUserJSON) : null;
  const userWS = loggedInUser ? loggedInUser.tlfwhatsapp : null;

  const [userdata, setUserdata] = useState("");

  const fetchUserInfo = async () => {
    try {
      const response = await axios.get(
        `https://api.mrcirp.com/public/infocampanas/${usuario}`
      );
      setUserdata(response.data[0]);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const fetchData = async () => {
    try {
      const response = await axios.get(`https://api.mrcirp.com/public/usuariolanding/${usuario}`);
      setData(response.data[0]);
    } catch (error) {
      console.error("Error fetching user info:", error);
    }
  };

  useEffect(() => {
    const fetchAllData = async () => {
      await fetchUserInfo();
      await fetchData();
    };
    fetchAllData();
  }, [usuario]);

  const handleEnded = () => {
    setShowQuestion(true);
    setVideoEnded(true);
  };

  const handleReplay = () => {
    setShowQuestion(false);
    setVideoEnded(false);
    playerRef.current.seekTo(0);
  };

  const handleOptionA = () => {
    trackViewContent();
    navigate(`/producto2/${usuario}`);
  };

  const handleOptionB = () => {
    navigate(`/unirsecliente/${usuario}`);
  };

  const handleOptionC = () => {
    navigate('/salir');
  };

  const handleBack = () => {
    navigate(-1);
  };

  if (!data) {
    return <div>Loading...</div>;
  }

  return (
    <div style={styles.container}>
      <div style={styles.content}>
        <h1>ZONA DE REVELACIÓN 1</h1>
        <div className="row">
          <div className={showQuestion ? "col-md-6 col-sm-12" : "col-md-12 col-sm-12"}>
            <div style={styles.videoWrapperFull}>
              <div style={styles.videoWrapper}>
                {data.urlvideoproducto1 && !videoEnded ? (
                  <ReactPlayer
                    ref={playerRef}
                    url={data.urlvideoproducto1}
                    width="100%"
                    height="100%"
                    controls={false}
                    onEnded={handleEnded}
                    style={styles.video}
                  />
                ) : (
                  <div style={styles.replayOverlay}>
                    <div style={styles.replayContent}>
                      <img src={cirpImage} alt="CIRP" style={styles.replayImage} />
                      <button style={styles.button} onClick={handleReplay}>Repetir video</button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
         
          {showQuestion && (
            <div className="col-md-6 col-sm-12">
              <div style={styles.questionBox}>
                <h4>¿Qué le pareció el video? … ¿Sorprendente cierto? ¿Como deseas continuar?</h4>
                <button style={styles.button} onClick={handleOptionA}>A) SÍ QUIERO MÁS INFORMACIÓN</button>
                <button style={styles.highlightButton} onClick={handleOptionB}>B) QUIERO UNIRME AL EQUIPO</button>
                <button style={styles.button} onClick={handleOptionC}>C) NO GRACIAS, DESEO SALIR</button>
                <button style={styles.button} onClick={handleBack}>VOLVER</button>
              </div>
            </div>
          )}
        </div>
      </div>
      <WhatsAppButton
           phoneNumber={userdata.whatsapp}
        message="Hola, me gustaría obtener más información."
        onContactClick={trackContact}
      />
      <SocialButtons
        pdfUrl={userdata.pdf}
        facebookUrl={userdata.facebook}
        instagramUrl={userdata.instagram}
        linkedinUrl={userdata.linkedin}
        tiktokUrl={userdata.tiktok}
        calendlyUrl={userdata.calendly}
        onContactClick={(network) => console.log(`Se hizo clic en ${network}`)}
      />
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundImage: `url(${bannerImage})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    minHeight: '100vh',
    padding: '20px',
    color: '#fff',
  },
  content: {
    textAlign: 'center',
    maxWidth: '1200px',
    width: '100%',
  },
  videoWrapperFull: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    position: 'relative',
  },
  videoWrapper: {
    position: 'relative',
    width: '100%',
    paddingTop: '56.25%', // 16:9 Aspect Ratio
  },
  video: {
    position: 'absolute',
    top: 0,
    left: 0,
  },
  replayOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    borderRadius: '10px',
  },
  replayContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '20px',
    width: '80%',
    textAlign: 'center',
  },
  replayImage: {
    width: '50%',
    marginBottom: '20px',
  },
  questionBox: {
    width: "100%",
    marginTop: "20px",
    padding: "20px",
    backgroundColor: "rgba(0, 0, 0, 0.7)",
    borderRadius: "10px",
    textAlign: "center",
  },
  button: {
    display: 'block',
    margin: '10px auto',
    padding: '10px 20px',
    fontSize: '16px',
    cursor: 'pointer',
    backgroundColor: '#fff',
    color: '#000',
    border: 'none',
    borderRadius: '5px',
    transition: 'background-color 0.3s, color 0.3s',
    width: '80%',
    maxWidth: '300px',
  },
  highlightButton: {
    display: 'block',
    margin: '10px auto',
    padding: '15px 25px',
    fontSize: '18px',
    cursor: 'pointer',
    backgroundColor: '#00f60a',
    color: '#000',
    border: '2px solid #000',
    borderRadius: '5px',
    transition: 'background-color 0.3s, color 0.3s',
    animation: 'pulse 1s infinite',
    width: '80%',
    maxWidth: '300px',
  },
  '@keyframes pulse': {
    '0%': {
      transform: 'scale(1)',
    },
    '50%': {
      transform: 'scale(1.05)',
    },
    '100%': {
      transform: 'scale(1)',
    },
  },
};

export default Producto1;